var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapClasses},[_vm._ssrNode("<input"+(_vm._ssrAttr("placeholder",_vm.placeholder))+(_vm._ssrAttr("disabled",_vm.disabled))+(_vm._ssrAttr("no-warning",_vm.phoneType))+(_vm._ssrAttr("autofocus",_vm.autofocus))+" type=\"text\""+(_vm._ssrAttr("value",(_vm.model)))+(_vm._ssrClass(null,_vm.inputClasses))+">")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77a01eac","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/format-input/index.vue
// module id = 722
// module chunks = 0 1 19